import React from "react";
import { connect } from "react-redux";
import DynamicMainScreen from "../../components/dynamicscreens/DynamicMainScreen";
import endpoint from "../../config/endpoints";
import {
  exportmsg,
  noInternetMsg,
  serverMsg,
} from "../../config/messageconstant";
import { ShowOrderListJson } from "../../DynamicFormsJson/MastersJSON/showOrderList";
import {
  getOrderListByDate,
  setOrderListShowOrder,
} from "../../Slice/OrderHeaderList.slice";
import { getStockStackHolders } from "../../Slice/StackHolder.slice";
import { OrderListColumns } from "../../tableColumns/table-columns";
import { apiGet } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import { downloadF } from "../PDF/PDFDownload";
import CheckBoxSelectionTable from "../../components/Comman/RT/CheckBoxSelectionTable";
import { withRouter } from "../../components/withRouter";
import { compose } from "@reduxjs/toolkit";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import { Grid, Paper } from "@mui/material";
import { ButtonCompo } from "../../components/Comman/Button";
import dayjs from "dayjs";

const columns = [
  {
    title: "Sr. No.",
    name: "index",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "Order No",
    name: "orderNo",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "Order Date",
    name: "orderDate",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "Firm Name",
    name: "stockHolder",
    positionCenter: false,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "SH Code",
    name: "fromOrderShCode",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  {
    title: "State Name",
    name: "fromOrderStateName",
    positionCenter: false,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "Area Name",
    name: "fromOrderAreaNames",
    positionCenter: false,
    canSearch: true,
    alignCenter: "left",
  },
  {
    title: "Total Quantity",
    name: "totalQty",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "Taxable Amount",
    name: "taxableAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "CGST",
    name: "cgstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "SGST",
    name: "sgstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "IGST",
    name: "igstAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "Total Amount",
    name: "totalAmt",
    positionCenter: false,
    canSearch: true,
    alignCenter: "right",
  },
  {
    title: "Status",
    name: "statusName",
    positionCenter: true,
    canSearch: true,
    align: "center",
  },
  { name: "action", title: "Action", alignCenter: "center" },
];
class ShowOrderListTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fromdate: "",
      todate: "",
      setList: [],
      showFilterDataExcel: "",
      selection: [],
      dynamicMasterData: {
        stakeholdersDetail: this.props.stakeholdersList.stockStakeHolders,
      },
    };
  }
  async componentDidMount() {
    const showFilterDataExcel = localStorage.getItem("showFilterDataWiseExcel");

    this.setState({ showFilterDataExcel });
    localStorage.removeItem("formData");
    this.getData();
  }
  getData = async () => {
    const { getOrderListByDate, showLoador, showNotification } = this.props;
    if (navigator.onLine) {

      const noOfDays = localStorage.getItem("daysForPrimaryOrderOnLoad");

      let fromDate = dayjs()
        .subtract(noOfDays && noOfDays !== null ? noOfDays : 7, "day")
        .format("DD-MM-YYYY");

      const toDate = dayjs().format("DD-MM-YYYY");

      await this.setState({ fromdate: "", todate: "" });


      showLoador({ loador: true });
      await getOrderListByDate({
        fromdate: fromDate,
        todate: toDate,
      }).then(({ success }) => {
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (this.props.stakeholdersList !== nextProps.stakeholdersList) {
      if (
        this.props.stakeholdersList?.stockStakeHolders !==
        nextProps.stakeholdersList?.stockStakeHolders
      ) {
        this.setState({
          dynamicMasterData: {
            ...this.state.dynamicMasterData,
            stakeholdersDetail: nextProps.stakeholdersList?.stockStakeHolders,
          },
        });
      }
    }
  }
  onSearchList = (data) => {
    const { getOrderListByDate, showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      getOrderListByDate({
        fromdate: data.fromdate,
        todate: data.todate,
      }).then(({ success }) => {
        this.setState({
          fromdate: data.fromdate ? data.fromdate : "",
          todate: data.todate ? data.todate : "",
        });
        showLoador({ loador: false });
        if (!success) {
          showNotification({ msg: serverMsg, severity: "error" });
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };
  rowPDF = (rowData) => {
    const { showLoador, showNotification } = this.props;
    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.stockStakeholderOrderHeader +
          "/report-by-id?documentType=1" +
          "&id=" +
          rowData.id,
        ext: "pdf",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  rowView = (rowData) => {
    this.props.navigate(ShowOrderListJson.formPathView + "/" + rowData.id);
  };

  getSelectedList = (e) => {
    const { showOrderList } = this.props;

    this.setState({
      selection: e,
    });
    const rowList = showOrderList.orderList.map((rowData) => {
      const filterData = e.filter((id) => rowData.id == id);
      return { ...rowData, checked: filterData.length != 0 ? true : false };
    });
  };

  generateExcel = (rowData) => {
    const { showLoador, showNotification } = this.props;
    const { fromdate, todate } = this.state;


    const noOfDays = localStorage.getItem("daysForPrimaryOrderOnLoad");

    const fromDateDefault = dayjs()
      .subtract(noOfDays && noOfDays !== null ? noOfDays : 7, "day")
      .format("DD-MM-YYYY");

    const toDateDefault = dayjs().format("DD-MM-YYYY");

    const fromDate = fromdate || fromDateDefault;
    const toDate = todate || toDateDefault;

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        url:
          endpoint.stockStakeholderOrderHeader +
          "/order-history-excel-by-date?fromDate=" +
          fromDate +
          "&toDate=" +
          toDate,
        ext: "xls",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  generateExcelNew = () => {
    const { showLoador, showNotification } = this.props;
    const { selection } = this.state;

    const dataToSave = {
      orderIds: selection,
    };

    if (selection.length == 0) {
      showNotification({
        msg: "Please select at least one order before exporting",
        severity: "error",
      });
      return;
    }

    if (navigator.onLine) {
      showLoador({ loador: true });
      downloadF({
        isGet: false,
        url: endpoint.exportData + "/stock-stack-holder-order-export-excel",
        postBody: dataToSave,
        ext: "xls",
        openNewTab: true,
      }).then((response) => {
        showLoador({ loador: false });
        if (!response) {
          this.props.showNotification({
            msg: serverMsg,
            severity: "error",
          });
        } else {
        }
      });
    } else {
      showNotification({ msg: noInternetMsg, severity: "error" });
    }
  };

  render() {
    const { showOrderList, setOrderListShowOrder } = this.props;
    const { dynamicMasterData, showFilterDataExcel, selection } = this.state;

    return (
      <>
        <Paper
          sx={{
            p: 2,
            borderRadius: 0,
          }}
          elevation={0}
        >
          <DynamicMainScreen
            showViewButtonInTable={true}
            showDeleteIcon={false}
            dynamicMasterData={dynamicMasterData}
            searchList={ShowOrderListJson.searchList}
            onSearchData={this.onSearchList}
            formPathView={ShowOrderListJson.formPathView}
            formPath={ShowOrderListJson.formPath}
            screenTitle={ShowOrderListJson.screenTitle}
            fieldMeta={ShowOrderListJson.fieldMeta}
            showExcelDownload={false}
            showPdfDownload={false}
            filterDataExcel={true}
            // staticExcel={showFilterDataExcel == 1 ? false : true}
            staticExcel={false}
            // generateExcelStatic={this.generateExcelStatic}
            isActiveURL={ShowOrderListJson.isActiveURL}
            showAddButton={false}
            tableColumnsToFilter={ShowOrderListJson.tableColumnsToFilter}
            // tableColumns={OrderListColumns}
            tableData={showOrderList.orderList}
            getTableData={this.getData}
            apiBaseURL={ShowOrderListJson.apiBaseURL}
            callApi={false}
            getTableDataById={true}
            rowPDF={this.rowPDF}
            showPdf={false}
            deleteURL={ShowOrderListJson.deleteURL}
            deleteURLStatic={true}
            showPegination={false}
            // showSearch={false}
            showSearchBox={false}
          />
          <LandingScreenHeader
            screenTitle={""}
            showTable={true}
            showSearchBox={false}
            showBackButton={false}
            showAddButton={false}
            showPdfDownload={false}
            showExcelDownload={showFilterDataExcel == 1 ? true : false}
            generateExcel={this.generateExcel}
          />
          <CheckBoxSelectionTable
            selection={selection}
            onSelectionChange={this.getSelectedList}
            disabled={true}
            rows={showOrderList.orderList}
            columns={columns}
            showDetailsIcon={true}
            showViewButtonInTable={true}
            rowView={this.rowView}
            // rowAppliedList={this.rowAppliedList}
            isActionColActive={true}
          // onSelectionChange={this.getRow}
          />
          <Grid
            item
            sm={12}
            xs={12}
            md={4}
            lg={4}
            sx={{ marginTop: 3, display: "flex", justifyContent: "flex-end" }}
          >
            <ButtonCompo
              size="medium"
              type="submit"
              variant="contained"
              name="Export"
              fullWidth={false}
              onClick={this.generateExcelNew}
            />
          </Grid>
        </Paper>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  stakeholdersList: state.stackholder,
  showOrderList: state.orderHeaderList,
});
const mapDispatchToProps = {
  showNotification,
  showLoador,
  getStockStackHolders,
  getOrderListByDate,
  setOrderListShowOrder,
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(ShowOrderListTable);
